"use strict";
import CommentsComponent from "src/decidim/comments/comments.component";
import { screens } from "tailwindcss/defaultTheme";
window.Decidim.CommentsComponent = CommentsComponent;
const debounce = (func, delay) => {
  let timeout = null;
  return (...args) => {
    clearTimeout(timeout);
    timeout = setTimeout(() => func(...args), delay);
  };
};
const initializeCommentsComponent = ($el) => {
  const commentsData = $el.data("decidim-comments");
  let comments = $el.data("comments");
  if (!comments) {
    comments = new CommentsComponent($el, commentsData);
    comments.mountComponent();
    $el.data("comments", comments);
  }
  return comments;
};
const updateCommentsComponent = ($el) => {
  const existingComments = $el.data("comments");
  if (existingComments && typeof existingComments.unmountComponent === "function") {
    existingComments.unmountComponent();
  }
  const newComments = new CommentsComponent($el, $el.data("decidim-comments"));
  newComments.mountComponent();
  $el.data("comments", newComments);
};
const commentsInitializer = () => {
  const smBreakpoint = parseInt(screens.md.replace("px", ""), 10);
  const isMobileScreen = () => window.matchMedia(`(max-width: ${smBreakpoint}px)`).matches;
  let wasMobileScreen = isMobileScreen();
  const commentElements = $("[data-decidim-comments]");
  const commentsMap = /* @__PURE__ */ new Map();
  commentElements.each((_i, el) => {
    const $el = $(el);
    const comments = initializeCommentsComponent($el);
    commentsMap.set($el, comments);
  });
  const handleResize = debounce(() => {
    const isNowMobileScreen = isMobileScreen();
    if (wasMobileScreen !== isNowMobileScreen) {
      commentElements.each((_i, el) => {
        const $el = $(el);
        updateCommentsComponent($el);
      });
      wasMobileScreen = isNowMobileScreen;
    }
  }, 200);
  window.addEventListener("resize", handleResize);
};
$(() => commentsInitializer());
